import React, { memo, useRef, useEffect, useCallback, useState} from 'react';
import {isMobile} from 'react-device-detect';
import {useContainerCoords} from "components/hooks/useContainerCoords.js"
import * as THREE from "three";
import {connect} from 'react-redux';

const ZCanvas3DComponent = memo(({isBackground, className, zobject, width, height}) => { 
    if (isBackground) {
        height = window.innerHeight - 80;
        width = window.innerWidth - 240;
    }
    if (zobject.attributes["fill subpatch"]) {
        let subpatch = zobject.subSequence;
        // need to find the top-most subpatch that isn't the subsequence
        while (subpatch.subSequence && !subpatch.subSequence.tracks) {
            subpatch = subpatch.subSequence;
        }
        console.log("top most subpatch=", subpatch);
        if (subpatch.zObject) {
            width = subpatch.zObject.width;
            height = subpatch.zObject.height;
        }
    }

    let isMouseDown = useRef(false);
    let ref = useRef(undefined);
    const scene = useRef(undefined);
    const renderer = useRef(undefined);
    const camera = useRef(undefined);
    const {getXY} = useContainerCoords({containerRef: ref, scale:1 });

    const onMouseMove = useCallback((e) => {
        if (!isMouseDown.current) {
            return;
        }
        if (e.touches) {
            e = e.touches[0];
        }
        let {x,y} = getXY(e);
        zobject.effect.onMouseMove(x,y);
    }, [zobject]);

    const onClick = useCallback((e) => {
        return;
        let {x,y} = getXY(e);
        zobject.effect.onMouseClick(x,y);
    }, [zobject]);

    const onMouseDown= useCallback((e) => {
        isMouseDown.current = true;
        if (isMobile && !e.touches) {
            return;
        }
        if (e.touches) {
            e = e.touches[0];
        }
        let {x,y} = getXY(e);
        zobject.effect.onMouseDown(x,y);
    }, [zobject]);

    const onMouseUp = useCallback((e) => {
        if (isMobile && !e.touches) {
            return;
        }
        isMouseDown.current = false;
        zobject.effect.onMouseUp();
    }, [zobject]);

    useEffect(() => {
        if (renderer.current) {
            renderer.current.setSize(width, height);
           renderer.current.setPixelRatio(window.devicePixelRatio);
        }
        if (zobject.effect) {
            console.log("sending size to=", width, height);
            zobject.effect.sendMessage('size', [width, height]);
        }
    }, [width, height, zobject]);
    
    useEffect(() => {
        if (zobject.effect.ctxt) {
            // dont add another context
            return;
        }
        renderer.current = new THREE.WebGLRenderer({antialias: true, preserveDrawingBuffer: true});
        zobject.effect.ctxt = renderer.current;
        zobject.effect.renderer = renderer.current;
       renderer.current.setSize(width, height);

        // TODO: use the window.devicePixelRatio (but this fucks up shit)
        renderer.current.setPixelRatio(2); 

        ref.current.appendChild( renderer.current.domElement );
        return () => zobject.effect.ctxt = undefined;
    }, []);
    
    return (<div
              className={className}
              onMouseMove={onMouseMove}
              onMouseDown={onMouseDown}
              onMouseUp={onMouseUp}
              onTouchMove={onMouseMove}
              onTouchStart={onMouseDown}
              onTouchEnd={onMouseUp}
              onClick={onClick}
              style={{width, height}}
              ref={ref} ></div>);
});

const mapStateToProps = (state, props) => {
    let outterPatch = getOutterPatch(props.zobject);
  return {
      isBackground: state.zobject.zobjectBackground && state.zobject.zobjectBackground.id === props.zobject.id,
      outerWidth: outterPatch && outterPatch.zObject && outterPatch.zObject.width,
      outerHeight: props.zobject.subSequence.zObject && props.zobject.subSequence.zObject.height,
      width: props.width || props.zobject.width,
      height: props.height || props.zobject.height,
  };
};

const getOutterPatch = (zobject) => {
    let subpatch = zobject.subSequence;
    // need to find the top-most subpatch that isn't the subsequence
    while (subpatch.subSequence && !subpatch.subSequence.tracks) {
        subpatch = subpatch.subSequence;
    }
    return subpatch;
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZCanvas3DComponent);
